import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/login.css";
import Logo from "../assets/img/Logo.png";
import { restablecerContrasena } from "../services/API";
import { FaEye, FaEyeSlash } from "react-icons/fa";

function RestablecerContrasena() {
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    //const { login } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    // Obtener la ruta original a la que el usuario intentaba acceder
    //const from = location.state?.from || "/reportes-general";

    const togglePasswordVisibility = () => setShowPassword(!showPassword);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMessage("");
        setIsLoading(true);

        const formData = new FormData(e.target);
        const email = formData.get("email");
        const newPassword = formData.get("newPassword");
        const repeatPassword = formData.get("repeatPassword");

        if (!email || !newPassword || !repeatPassword) {
            setErrorMessage("Por favor complete todos los campos.");
            setIsLoading(false);
            return;
        }

        if (newPassword !== repeatPassword) {
            setErrorMessage("Las Contraseñas deben Coincidir");
            setIsLoading(false);
            return;
        }

        try {
            const response = await restablecerContrasena(email,newPassword);
            //console.log("Response del backend",response.status);
            if (response) {
                navigate("/login",{ state: { successMessage: "Contraseña Restablecida" } });
            } else {
                setErrorMessage(response.error || "Error al Restablecer Contraseña");
            }
        } catch (error) {
            setErrorMessage(error.message || "Error inesperado al Restablecer Contraseña");
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="general-login">
            <div className="cuadro-login">
                <a href="/" className="logo">
                    <img src={Logo} alt="Logo" />
                </a>
                <div className="pt-2 pb-1 text-center">
                    <h3 className="card-title my-3">
                        <a className="text-decoration-none text-dark">
                            Restablecer Contraseña
                        </a>
                    </h3>
                </div>

                {errorMessage && (
                    <div className="alert alert-danger" role="alert">
                        {errorMessage}
                    </div>
                )}

                <form
                    className="input-login row g-3 needs-validation"
                    onSubmit={handleSubmit}
                    noValidate
                >
                    <div className="col-12">
                        <input
                            type="email"
                            name="email"
                            className="form-control-login"
                            placeholder="Correo Electrónico"
                            required
                            disabled={isLoading}
                        />
                        <div className="invalid-feedback">Por favor ingrese su correo.</div>
                    </div>

                    <div className="col-12 position-relative">
                        <div className="mb-3 position-relative">
                            <input
                                type={showPassword ? "text" : "password"}
                                name="newPassword"
                                placeholder="Nueva Contraseña"
                                className="form-control-login"
                                required
                                disabled={isLoading}
                            />
                            <button
                                type="button"
                                className="password-toggle-btn"
                                onClick={togglePasswordVisibility}
                                disabled={isLoading}
                            >
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </button>
                        </div>

                        <div className="mb-3 position-relative">
                            <input
                                type={showPassword ? "text" : "password"}
                                name="repeatPassword"
                                placeholder="Repita Contraseña"
                                className="form-control-login"
                                required
                                disabled={isLoading}
                            />
                            <button
                                type="button"
                                className="password-toggle-btn"
                                onClick={togglePasswordVisibility}
                                disabled={isLoading}
                            >
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </button>
                        </div>
                        
                        <div className="invalid-feedback">Por favor ingrese su contraseña.</div>
                    </div>

                    <div className="boton-login">
                        <button
                            className="btn btn-primary"
                            type="submit"
                            disabled={isLoading}
                        >
                            {isLoading ? "Restableciendo..." : "Restablecer Contraseña"}
                        </button>
                    </div>
                    <a href="/login" className="text-center">Regresar</a>
                    <br></br>
                </form>
            </div>
        </div>
    );
}

export default RestablecerContrasena;